/**
 * @generated SignedSource<<2940f6886624b0edfd7bbf69c3d7dc3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_item$data = {
  readonly isDepositAvailable: boolean;
  readonly returnPolicy: {
    readonly buyerCopy: {
      readonly returnPolicySectionHeader: {
        readonly htmlCopy: string | null;
      } | null;
    } | null;
  } | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailReturnPolicy_item" | "PdpSharedDepositPaymentDetail_item" | "PdpSharedDetailShipping_item" | "PdpSharedBuyerProtectionBox_item" | "PdpRespRecentSales_item">;
  readonly " $fragmentType": "PdpRespShippingReturns_item";
};
export type PdpRespShippingReturns_item$key = {
  readonly " $data"?: PdpRespShippingReturns_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespShippingReturns_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReturnPolicy_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDepositPaymentDetail_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerProtectionBox_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespRecentSales_item"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        }
      ],
      "kind": "ScalarField",
      "name": "isDepositAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "ReturnPolicy",
      "kind": "LinkedField",
      "name": "returnPolicy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReturnPolicyCopy",
          "kind": "LinkedField",
          "name": "buyerCopy",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "InlineCtaCopy",
              "kind": "LinkedField",
              "name": "returnPolicySectionHeader",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "htmlCopy",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "2453662313a09fdcb64b940ab0092beb";

export default node;
